<template>
  <div class="algebra-kit-component">
    <div class="algebra-kit-content">
      <div class="sls-algebra-kit-content" :data-spec="dataSpec.replaceAll('$$', '##')">
        <akit-content-view :content="dataSpec.replaceAll('$$', '##')" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useDynamicMountChild } from "@plugins/common/composables/dynamic-mount-child.ts";

const props = withDefaults(
  defineProps<{
    dataSpec?: string;
    // eslint-disable-next-line vue/prop-name-casing
    dynamicMountChildMixin_parentComponent?: object;
    // eslint-disable-next-line vue/prop-name-casing
    dynamicMountChildMixin_isDynamicallyMounted?: boolean;
  }>(),
  {
    dataSpec: "",
    dynamicMountChildMixin_parentComponent: () => ({}),
    dynamicMountChildMixin_isDynamicallyMounted: false,
  },
);

useDynamicMountChild({
  dynamicMountChildMixin_parentComponent: props.dynamicMountChildMixin_parentComponent,
  dynamicMountChildMixin_isDynamicallyMounted: props.dynamicMountChildMixin_isDynamicallyMounted,
});
</script>
